export default __webpack_public_path__ + "src/assets/images/Banner_Geschenkgutschein_WEINACHTEN24.jpg";